export const resizeEmulate = () => {
  window.dispatchEvent(new Event('resize'));
};
